import React, {Component} from "react";
import Modal from "react-modal";
// import Creatable from "react-select/lib/Creatable";

const customStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)"
	}
};
export default class DecModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      declaration: {
        woman: undefined,
        aboriginal: undefined,
        minority: undefined,
        disability: undefined,
      }
    }
  }

	componentDidMount () {
		console.log(this.props.declaration)
		if (this.props.declaration) {
			if (this.props.declaration.woman === "No") {
				this.setState({woman1Checked:true})
			} else if ( this.props.declaration.woman === "Yes") {
				this.setState({woman2Checked:true})
			} else {
				this.setState({woman3Checked:true})
			}

			if (this.props.declaration.minority === "No") {
				this.setState({minority1Checked:true})
			} else if ( this.props.declaration.minority === "Yes") {
				this.setState({minority2Checked:true})
			} else {
				this.setState({minority3Checked:true})
			}

			if (this.props.declaration.aboriginal === "No") {
				this.setState({aboriginal1Checked:true})
			} else if ( this.props.declaration.aboriginal === "Yes") {
				this.setState({aboriginal2Checked:true})
			} else {
				this.setState({aboriginal3Checked:true})
			}

			if (this.props.declaration.disability === "No") {
				this.setState({disability1Checked:true})
			} else if ( this.props.declaration.aboriginal === "Yes") {
				this.setState({disability2Checked:true})
			} else {
				this.setState({disability3Checked:true})
			}
			this.setState({
				declaration: this.props.declaration,
			});
		}
	}

  openModal = (e) => {
    e.preventDefault();
    this.setState({
      modalIsOpen: true
    });
  };

  afterOpenModal = () => {};

  closeModal = () => {
    this.setState({
      modalIsOpen: false
    });
  };

  handleChange = e => {
    let target = e.target;
    this.setState({
      declaration: {
        ...this.state.declaration,
        [target.name]: e.target.value
      }
    });
  }

  setDeclaration = () => {
		this.props.setDeclaration(this.state.declaration);
		this.closeModal()
  }

  render() {
		if (this.props.display === "disabled") {
			return(
	      <div>
	        <button onClick={this.openModal} className="btn btn-info">View Self-declaration form</button>
	        <Modal
	          isOpen={this.state.modalIsOpen}
	          onAfterOpen={this.afterOpenModal}
	          onRequestClose={this.closeModal}
	          style={customStyles}
	          ariaHideApp={false}
	        >
					<div style={{overflowY: "scroll", maxHeight: '80vh'}}>
						<h3 style={{textAlign: 'center'}}>Self-declaration</h3>
						<form className="col-10 offset-1">
							<div className="form-group my-4">
							 <h4>Collection and Use of Equity Information</h4>
								<ul>
									<li>	• Information is collected on the basis or self-identification</li>
									<li>	• Information provided by individuals is treated as confidential</li>
									<li>	• The KingstonConnect office will disclose relevant self-identification information to approved partners at the stages of the search where equity may be relevant</li>
									<li>	• You may also choose the option “do not wish to self-identify”</li>
								</ul>
								<h4>Complete the appropriate fields.</h4>
								<p>
									<strong>Note:</strong> The definitions and categories of designated groups used here are consistent with those used
									by Census Canada, the Employment Equity Act, (1995), c. 44 and the Federal Contractors Program (FCP).
									<br/>
									<strong>Note:</strong> Should you wish to self-identify, you may do so in more than one category if applicable
								</p>
							</div>
							<div className="form-group my-4">
								<strong>1) Women</strong><br/>
								Do you self-indentify as a woman?{" "}
								<div className="custom-control custom-radio custom-control-inline">
									<input type="radio" id="woman1" name="woman" className="custom-control-input" checked={this.state.woman1Checked} disabled/>
									<label className="custom-control-label" htmlFor="woman1">No</label>
								</div>
								<div className="custom-control custom-radio custom-control-inline">
									<input type="radio" id="woman2" name="woman" className="custom-control-input" checked={this.state.woman2Checked} disabled/>
									<label className="custom-control-label" htmlFor="woman2">Yes</label>
								</div>
								<div className="custom-control custom-radio custom-control-inline">
									<input type="radio" id="woman3" name="woman" className="custom-control-input" checked={this.state.woman3Checked} disabled/>
									<label className="custom-control-label" htmlFor="woman3">Prefer not to answer</label>
								</div>
							</div>
							<div className="form-group my-4">
								<strong>2) Racialized Group/Visible Minority:</strong><br/>
								Do you self-identify as a member of a racialized group/visible minority in Canada?{" "}
								<div className="custom-control custom-radio custom-control-inline">
									<input type="radio" id="minority1" name="minority" className="custom-control-input" checked={this.state.minority1Checked} disabled/>
									<label className="custom-control-label" htmlFor="minority1">No</label>
								</div>
								<div className="custom-control custom-radio custom-control-inline">
									<input type="radio" id="minority2" name="minority" className="custom-control-input" checked={this.state.minority2Checked} disabled/>
									<label className="custom-control-label" htmlFor="minority2">Yes</label>
								</div>
								<div className="custom-control custom-radio custom-control-inline">
									<input type="radio" id="minority3" name="minority" className="custom-control-input" checked={this.state.minority3Checked} disabled/>
									<label className="custom-control-label" htmlFor="minority3">Prefer not to answer</label>
								</div>
							</div>
							<div className="form-group my-4">
								<strong>3) Indigenous/Aboriginal Peoples</strong><br/>
								Are you an Aboriginal person?{" "}
								<div className="custom-control custom-radio custom-control-inline">
									<input type="radio" id="aboriginal1" name="aboriginal" className="custom-control-input" checked={this.state.aboriginal1Checked} disabled/>
									<label className="custom-control-label" htmlFor="aboriginal1">No</label>
								</div>
								<div className="custom-control custom-radio custom-control-inline">
									<input type="radio" id="aboriginal2" name="aboriginal" className="custom-control-input" checked={this.state.aboriginal2Checked} disabled/>
									<label className="custom-control-label" htmlFor="aboriginal2">Yes</label>
								</div>
								<div className="custom-control custom-radio custom-control-inline">
									<input type="radio" id="aboriginal3" name="aboriginal" className="custom-control-input" checked={this.state.aboriginal3Checked} disabled/>
									<label className="custom-control-label" htmlFor="aboriginal3">Prefer not to answer</label>
								</div>
							</div>

							<div className="form-group my-4">
								<strong>4) Person with a Disability: </strong><br/>
								Do you self-indentify as a person with a disability?{" "}
								<div className="custom-control custom-radio custom-control-inline">
									<input type="radio" id="disability1" name="disability" className="custom-control-input" checked={this.state.disability1Checked} disabled/>
									<label className="custom-control-label" htmlFor="disability1">No</label>
								</div>
								<div className="custom-control custom-radio custom-control-inline">
									<input type="radio" id="disability2" name="disability" className="custom-control-input" checked={this.state.disability2Checked} disabled/>
									<label className="custom-control-label" htmlFor="disability2">Yes</label>
								</div>
								<div className="custom-control custom-radio custom-control-inline">
									<input type="radio" id="disability3" name="disability" className="custom-control-input" checked={this.state.disability3Checked} disabled/>
									<label className="custom-control-label" htmlFor="disability3">Prefer not to answer</label>
								</div>
							</div>
						</form>
						<div style={{textAlign: 'center'}}>
							<p className='col-8 offset-2'>Where an external recruitment partner or community partner is used, I authorize KingstonConnect to share my personal information to that partner for the sole purpose of assisting with recruitment and I understand that such partners are bound by strict confidentiality requirements. </p>
							<button className="btn btn-danger col-3" onClick={this.closeModal}> Close</button>
						</div>
					</div>
	        </Modal>

	      </div>
	    )

		} else {
	    return(
	      <div>
	        <button onClick={this.openModal} className="btn btn-info">Minority Self-declaration form</button>
	        <Modal
	          isOpen={this.state.modalIsOpen}
	          onAfterOpen={this.afterOpenModal}
	          onRequestClose={this.closeModal}
	          style={customStyles}
	          ariaHideApp={false}
	        >
	          <div style={{overflowY: "scroll", maxHeight: '80vh'}}>
	            <h3 style={{textAlign: 'center'}}>Self-declaration</h3>
	            <form className="col-10 offset-1">
	              <div className="form-group my-4">
								 <h4>Collection and Use of Equity Information</h4>
									<ul>
										<li>	• Information is collected on the basis or self-identification</li>
										<li>	• Information provided by individuals is treated as confidential</li>
										<li>	• The KingstonConnect office will disclose relevant self-identification information to approved partners at the stages of the search where equity may be relevant</li>
										<li>	• You may also choose the option “do not wish to self-identify”</li>
									</ul>
	                <h4>Complete the appropriate fields.</h4>
									<p>
										<strong>Note:</strong> The definitions and categories of designated groups used here are consistent with those used
										by Census Canada, the Employment Equity Act, (1995), c. 44 and the Federal Contractors Program (FCP).
										<br/>
										<strong>Note:</strong> Should you wish to self-identify, you may do so in more than one category if applicable
									</p>
	              </div>
	              <div className="form-group my-4">
	                <strong>1) Women</strong><br/>
									Do you self-indentify as a woman?{" "}
									<div className="custom-control custom-radio custom-control-inline">
									  <input onChange={this.handleChange} type="radio" id="woman1" name='woman' value="No" className="custom-control-input"/>
									  <label className="custom-control-label" htmlFor="woman1">No</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline">
									  <input onChange={this.handleChange} type="radio" id="woman2" name='woman' value="Yes" className="custom-control-input" />
									  <label className="custom-control-label" htmlFor="woman2">Yes</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline">
										<input onChange={this.handleChange} type="radio" id="woman3" name='woman' value="Prefer not to answer" className="custom-control-input" />
										<label className="custom-control-label" htmlFor="woman3">Prefer not to answer</label>
									</div>
	              </div>
								<div className="form-group my-4">
									<strong>2) Racialized Group/Visible Minority:</strong><br/>
									Do you self-identify as a member of a racialized group/visible minority in Canada?{" "}
									<div className="custom-control custom-radio custom-control-inline">
									  <input onChange={this.handleChange} type="radio" id="minority1" name='minority' value="No" className="custom-control-input" />
									  <label className="custom-control-label" htmlFor="minority1">No</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline">
									  <input onChange={this.handleChange} type="radio" id="minority2" name='minority' value="Yes" className="custom-control-input"/>
									  <label className="custom-control-label" htmlFor="minority2">Yes</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline">
										<input onChange={this.handleChange} type="radio" id="minority3" name='minority' value="Prefer not to answer" className="custom-control-input"/>
										<label className="custom-control-label" htmlFor="minority3">Prefer not to answer</label>
									</div>
								</div>
	              <div className="form-group my-4">
	                <strong>3) Indigenous/Aboriginal Peoples</strong><br/>
	                Are you an Aboriginal person?{" "}
									<div className="custom-control custom-radio custom-control-inline">
									  <input onChange={this.handleChange} type="radio" id="aboriginal1" name='aboriginal' value="No" className="custom-control-input" />
									  <label className="custom-control-label" htmlFor="aboriginal1">No</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline">
									  <input onChange={this.handleChange} type="radio" id="aboriginal2" name='aboriginal' value="Yes" className="custom-control-input" />
									  <label className="custom-control-label" htmlFor="aboriginal2">Yes</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline">
										<input onChange={this.handleChange} type="radio" id="aboriginal3" name='aboriginal' value="Prefer not to answer" className="custom-control-input" />
										<label className="custom-control-label" htmlFor="aboriginal3">Prefer not to answer</label>
									</div>
	              </div>

	              <div className="form-group my-4">
	                <strong>4) Person with a Disability: </strong><br/>
	                Do you self-indentify as a person with a disability?{" "}
									<div className="custom-control custom-radio custom-control-inline">
									  <input onChange={this.handleChange} type="radio" id="disability1" name='disability' value="No" className="custom-control-input" />
									  <label className="custom-control-label" htmlFor="disability1">No</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline">
									  <input onChange={this.handleChange} type="radio" id="disability2" name='disability' value="Yes" className="custom-control-input" />
									  <label className="custom-control-label" htmlFor="disability2">Yes</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline">
										<input onChange={this.handleChange} type="radio" id="disability3" name='disability' value="Prefer not to answer" className="custom-control-input" />
										<label className="custom-control-label" htmlFor="disability3">Prefer not to answer</label>
									</div>
	              </div>
	            </form>
	            <div style={{textAlign: 'center'}}>
								<p className='col-8 offset-2'>Where an external recruitment partner or community partner is used, I authorize KingstonConnect to share my personal information to that partner for the sole purpose of assisting with recruitment and I understand that such partners are bound by strict confidentiality requirements. </p>
	              <button onChange={this.handleChange} className="btn btn-danger col-3" onClick={this.closeModal}> Cancel</button>
	              <button onClick={this.setDeclaration} className="btn btn-primary col-3">Save</button>
	            </div>
	          </div>
	        </Modal>
	      </div>
	    )
		}
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/DecModal.js